import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { urlFor } from '../client';

const Service = ({
  id,
  imgUrl,
  name,
  projectLink,
  codeLink,
  title,
  description,
  tags,
}) => {
  const [show, setShow] = useState(false);
  const handleClick = (e) => {
    if (e.target.value) {
      setShow(!show);
    }
  };
  return (
    <div className="app__work-item app__flex" key={id}>
      <div className="app__work-img app__flex">
        <img src={urlFor(imgUrl)} alt={name} />

        <motion.div
          whileHover={{ opacity: [0, 1] }}
          transition={{
            duration: 0.25,
            ease: 'easeInOut',
            staggerChildren: 0.5,
          }}
          className="app__work-hover app__flex"
        >
          <a href={projectLink} target="_blank" rel="noreferrer">
            <motion.div
              whileInView={{ scale: [0, 1] }}
              whileHover={{ scale: [1, 0.9] }}
              transition={{ duration: 0.25 }}
              className="app__flex"
            >
              <AiFillEye />
            </motion.div>
          </a>
          {codeLink && (
            <a href={codeLink} target="_blank" rel="noreferrer">
              <motion.div
                whileInView={{ scale: [0, 1] }}
                whileHover={{ scale: [1, 0.9] }}
                transition={{ duration: 0.25 }}
                className="app__flex"
              ></motion.div>
            </a>
          )}
        </motion.div>
      </div>
      <div className="app__work-content app__flex">
        <h4 className="bold-text text-left">{title}</h4>
        <p className="p-text desc">
          {show ? description : description.substring(0, 40)}
        </p>
        <button
          type="button"
          className="read-btn active:bg-red-400"
          value={id}
          onClick={(e) => handleClick(e)}
        >
          Read
          {!show ? ' more' : ' less'}{' '}
        </button>
        <div className="app__work-tag app__flex">
          <p className="p-text tags">{tags}</p>
        </div>
      </div>
    </div>
  );
};

export default Service;
